const Kategoriya2111 = () => {
    return (
        <div style={{ fontFamily: "Times New Roman", fontSize: "14pt" }} className="container mt-5">
            <h3 className="text-center text-primary">
                2-sinf 1-chorak<br />
                Mavzu: Unli va undosh tovushlar <br />
“Eng oson” bo‘limidagi topshiriqlar va ularni o‘tkazish metodikasi
            </h3>
            <b>1-mashq. Nuqtalar o‘rniga qaysi so‘zni qo‘yish mumkin?</b><br />
            <i>Ta’limiy maqsad:</i> O‘quvchilarning so‘z tanlash mahoratini oshirish. <br />
            <i>Mashg‘ulot davomiyligi:</i> 3-4 daqiqa <br />
            Echki  … (nima qiladi?) <br />
            (Kim?) ….  mehribon.
            <p><b>2-mashq.  Qaysi harf tushib qolgan?</b></p>
            <p><i>Ta’limiy maqsad:</i> O‘quvchilarning imloviy malakalarini rivojlantirish.</p>
            <p><i>Mashg‘ulot davomiyligi:</i>1-2 daqiqa.</p>
            <p>Olm…, samoly…t.</p>
            <p><b>3-mashq.  To‘g‘risini yozing.</b></p>
            <p><i>Ta’limiy maqsad:</i>O‘quvchilarni imloviy hushyorlikka chorlash.</p>
            <p><i>Mashg‘ulot davomiyligi:</i>2-3 daqiqa.</p>
            <ul>
                <li>abady</li>
                <li>ko‘rk</li>
                <li>saylgoh</li>
                <li>mexrsiz</li>
                <li>ota ona</li>
            </ul>
            <p><b>4-mashq.  Tarkibida bir unli bo‘lgan so‘zlarni yozing.</b></p>
            <p><i>Ta’limiy maqsad:</i>O‘quvchilarni unli va undoshlarni farqlashga o‘rgatish.</p>
            <p><i>Mashg‘ulot davomiyligi:</i>2-3 daqiqa.</p>
            <ul>
                <li>ona</li>
                <li>gul</li>
                <li>daryo</li>
                <li>sohil</li>
                <li>amr</li>
            </ul>
            <p><b>5-mashq. Juftlikda ishlash. Faqat bir tovush bilan farqlanadigan so‘zlarni yozing.</b></p>
            <p><i>Ta’limiy maqsad:</i>O‘quvchilarni imloviy savodxonligini oshirish.</p>
            <p><i>Mashg‘ulot davomiyligi:</i>2-3 daqiqa.</p>
            <p>Tosh, kitob, choh, dosh, bemor, bosh, ruchka, barg, tut.</p>
            <p><b>6-mashq.  Nuqtalar o‘rniga mos so‘zni tanlab yozing?</b></p>
            <p><i>Ta’limiy maqsad:</i>O‘quvchilarning lingvistik ko‘nikmalarini rivojlantirish.</p>
            <p><i>Mashg‘ulot davomiyligi:</i>3-4 daqiqa.</p>
            <p>Tabiatning musaffo, … (jazirama, salqin, quruq, nam) havosi etni junjiktiradi.</p>
            <p>Jazirama sahroda … (quruq, nam, sovuq, issiq) havoni topish dargumon.</p>
            <p><b>7-mashq.  Maqolning davomini yozing.</b></p>
            <p><i>Ta’limiy maqsad:</i>O‘quvchilarning sintaktik ko‘nikmalarini rivojlantirish.</p>
            <p><i>Mashg‘ulot davomiyligi:</i>3-4 daqiqa.</p>
            <p>Mehnat qilsang – …  … .</p>
            <p>…  … , duo ol.</p>
        </div>
    )
}
export default Kategoriya2111;